module.exports = __webpack_public_path__ + "static/Shivangi_Balodia-7954105255f182226a6dcae9141c9763.jpeg";